<template>
 <ul class="px-[10px]">
    <AssetCard
      v-for="value in filteredTransactions(assets).items"
      :key="value.id || value.value"
      :asset="value" />
    <div v-if="getTotalCount(assets) > maxResults" class="flex justify-end mt-[5px]">
      <a
        @click="loadMoreResults"
        class="max-w-fit-content px-4 py-2 text-blue-dark font-jost-semibold text-right rounded-lg hover:bg-blue-700 transition-colors duration-200 block cursor-pointer">
        Show more
      </a>
    </div>
  </ul>
</template>

<script>
import { filteredTransactions } from '@/helpers/common';
import { MAX_SEARCH_RESULTS } from '@/helpers/constants';
import AssetCard from '@/components/common/AssetCard.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'AssetsList',
  components: {
    AssetCard,
  },
  props: {
    assets: {
      type: Object,
      default: () => ({ items: [] })
    }
  },
  data() {
    return {
      uiTypes: UiTypes,
      maxResults: MAX_SEARCH_RESULTS,
    };
  },
  methods: {
    filteredTransactions(list) {
      return filteredTransactions(list);
    },
    getTotalCount(list) {
      if (!list) return 0;
      if (typeof list.total === 'number') return list.total;
      return 0;
    },
    loadMoreResults() {
      this.$router.push({
        name: 'resultsByType',
        params: { type: this.uiTypes.asset },
        query: this.$route.query
      });
    }
  }
}
</script>
